import {
  ActivatedRouteSnapshot,
  ResolveFn,
  Route,
  RouterStateSnapshot,
} from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { hasScopesGuard, hasScopesResolver } from '@mds/ngx-auth';
import { DriverResponse } from '../../shared/services/api-client';
import { driverResolverFactory } from './resolvers/driver.resolver';

export const driverRoutes: Route[] = [
  {
    path: '',
    title: _('i18n.Driver.List.Title'),
    loadComponent: () =>
      import('./components/driver-list/driver-list.component').then(
        (m) => m.DriverListComponent,
      ),
    resolve: { hasWriteScope: hasScopesResolver(['drivers:write']) },
  },
  {
    path: ':driverId',
    children: [
      {
        path: 'detail',
        resolve: {
          driver: (
            route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot,
          ): ReturnType<ResolveFn<DriverResponse | undefined>> => {
            const driverIdRaw = route.paramMap.get('driverId');
            const driverId = Number(driverIdRaw);

            const driverResolver = driverResolverFactory(driverId);
            return driverResolver(route, state);
          },
          hasWriteScope: hasScopesResolver(['drivers:write']),
        },
        loadComponent: () =>
          import('./components/driver-detail/driver-detail.component').then(
            (m) => m.DriverDetailComponent,
          ),
      },
      {
        path: 'edit',
        resolve: {
          driver: (
            route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot,
          ): ReturnType<ResolveFn<DriverResponse | undefined>> => {
            const driverIdRaw = route.paramMap.get('driverId');
            const driverId = Number(driverIdRaw);

            const driverResolver = driverResolverFactory(driverId);
            return driverResolver(route, state);
          },
          hasWriteScope: hasScopesResolver(['drivers:write']),
        },
        loadComponent: () =>
          import('./components/driver-edit/driver-edit.component').then(
            (m) => m.DriverEditComponent,
          ),
        canActivate: [hasScopesGuard(['drivers:write'])],
      },
    ],
  },
];
